import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { SidebarTaskUi } from '../../model/sidebar.model';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PayerPortalTaskTemplateComponent } from './components/task-card-templates/payer-portal-task-template/payer-portal-task-template.component';
import { MailPackageTaskTemplateComponent } from './components/task-card-templates/mail-package-task-template/mail-package-task-template.component';
import { CreatePackageTaskTemplateComponent } from './components/task-card-templates/create-package-task-template/create-package-task-template.component';
import { CallPayerTaskTemplateComponent } from './components/task-card-templates/call-payer-task-template/call-payer-task-template.component';
import { ReviewTaskTemplateComponent } from './components/task-card-templates/review-task-template/review-task-template.component';
import { TaskTypes } from 'src/app/shared/models/tasks.model';
import { SidebarState } from '../../state/sidebar.state';
import { ManualPortalTaskTemplateComponent } from './components/task-card-templates/manual-portal-task-template/manual-portal-task-template.component';

@Component({
  selector: 'ri-resolution-ui-sidebar-task',
  templateUrl: './sidebar-task.component.html',
  imports: [
    PayerPortalTaskTemplateComponent,
    MailPackageTaskTemplateComponent,
    CreatePackageTaskTemplateComponent,
    CallPayerTaskTemplateComponent,
    ReviewTaskTemplateComponent,
    RouterLink,
    RouterLinkActive,
    ManualPortalTaskTemplateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarTaskComponent {
  public readonly sidebarState = inject(SidebarState);

  readonly task = input.required<SidebarTaskUi>();
  readonly taskTypes = TaskTypes;
}
